import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react/components/Modal/Modal';
import { getResourceTo } from 'react/utils/utils';
import {
  Button,
  Flex,
  LookupMultiSelect,
  Text
} from 'onefaceui-react-components';
import { getLookupExtraParams } from 'react/utils/lookupUtils';
import { useDispatch } from 'react-redux';
import routeSummary from 'react/api/actions/routeSummary';

function RouteSummaryAssignDriverModal({ isOpen }) {
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(routeSummary.actionCreators.assignDriverModal.closeModal());
  }, [dispatch]);
  const handleSaveSelection = useCallback(() => {
    dispatch(
      routeSummary.actionCreators.dispatchAssignDriver({
        drivers: selectedDrivers
      })
    );
  }, [dispatch, selectedDrivers]);

  return (
    isOpen && (
      <Modal
        isOpen={isOpen}
        title={getResourceTo('RouteSummaryAssignDriverModal.Title')}
        subtitle={getResourceTo('routeSummaryAssignDriverModal.subtitle')}
        className="driver-lookup-modal route-summary-modal"
        crossAxisBtn={false}
        footer={
          <Flex
            justifyContent="flex-end"
            flexDirection="row"
            gap={15}
            style={{ padding: '10px 15px', borderTop: '1px solid #D0D7DD' }}
          >
            <Button
              variant="secondary"
              dataTestId="assign-driver-modal-close-btn"
              onClick={handleClose}
            >
              {getResourceTo('default.button.cancel')}
            </Button>
            <Button
              variant="primary"
              dataTestId="assign-driver-modal-apply-btn"
              onClick={handleSaveSelection}
              disabled={!selectedDrivers.length}
            >
              {getResourceTo('default.button.save')}
            </Button>
          </Flex>
        }
      >
        <Flex flexDirection="column" gap={9}>
          <Text type="primary" size="md">
            {getResourceTo('routeSummaryAssignDriverModal.driverAssignments')}
          </Text>
          <LookupMultiSelect
            label={getResourceTo('routeSummaryAssignDriverModal.selectDrivers')}
            name="driver"
            displayMode="form"
            defaultValue={selectedDrivers}
            onRemoveAll={() => setSelectedDrivers([])}
            onRemoveItem={(filteredData) => {
              setSelectedDrivers(filteredData);
            }}
            onSelectValues={(values) => {
              setSelectedDrivers(values);
            }}
            {...getLookupExtraParams({
              entity: 'Driver',
              defaultField: 'name',
              autoComplete: 'off'
            })}
          />
        </Flex>
      </Modal>
    )
  );
}

RouteSummaryAssignDriverModal.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

export default RouteSummaryAssignDriverModal;
